import { Injectable, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { AlertaService } from '../alertaService';
import { GlobalService } from '../global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { WindowService } from '@progress/kendo-angular-dialog';
import { PlatformLocation } from '@angular/common';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private globalService: GlobalService, private alertaService: AlertaService, 
    private SpinnerService: NgxSpinnerService, private router: Router 
    ,private platformLocation: PlatformLocation,
    private ngZone: NgZone) { }



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      //
      switch (err.status) {
        case 400:
          this.alertaService.error('Lo sentimos, error en la solicitud, verifique los datos.', false)
          break;
        case 401:
          sessionStorage.clear();
          this.globalService.esErrorPeticion = true;
          if (this.globalService.Directorio == true) {
            //console.log('error Directorio');
            this.globalService.LoadDir = true;
            this.platformLocation.onPopState(() => {
              if(this.platformLocation.pathname.startsWith("Directorio")) {
                  this.ngZone.run(() => {
                     // console.log("Reloading component");
                  });
              }
          })
            // this.router.onSameUrlNavigation = 'reload';
            // this.router.navigateByUrl(this.router.url).then(() => {

            //   this.router.onSameUrlNavigation = 'ignore';

            // });
            // this.router.navigateByUrl('DummyComponent', {skipLocationChange: true}).then(()=>{
            //   this.router.navigate(['Directorio']);}
            // );
            //alert("Lo sentimos, se volverá a recargar la página.")
          } else {
            this.router.navigate(['autenticacion/login'], { skipLocationChange: true });
            alert("Lo sentimos, la sesión ha expirado.")
          }
          break;
        case 500:
          this.alertaService.error('Lo sentimos, error interno del servidor. Intente más tarde.', false)
          break;
        case 404:
          this.alertaService.error('Lo sentimos, No se encontró la opción solicitada.', false)
          break;
        default:
          this.alertaService.error('Lo sentimos, error interno del servidor. Intente más tarde.', false)
          break;
      }
      this.SpinnerService.hide();
      const error = (err.error != null ? err.error.message : err.statusText);
      return throwError(error);
    }))
  }
}